import { MONTH_END_RETURN_NAV } from '../../../../constants/constant.content'
import { FilterGroup } from './filter-group-enum'
import { FilterState } from './filter-state'
import { IFilterState } from './ifilter-state'

export class UnmodifiableFilterStateWrapper implements IFilterState {
  private filterState: FilterState
  setFilterState(filterState: FilterState) {
    this.filterState = filterState
  }

  getAllFilterSelections(): string[] {
    let allFilterSelectionAry: string[] = []
    this.filterState
      .getConsolidatedFilterGroupStateMap()
      .forEach((filterSelectionAry: string[]) => {
        allFilterSelectionAry = [
          ...allFilterSelectionAry,
          ...filterSelectionAry,
        ]
      })
    return allFilterSelectionAry
  }

  getDisplaySelection(): string {
    return this.filterState.getSelectedDisplayType()
  }

  getFilterSelections(filterGroup: FilterGroup): string[] {
    return this.filterState
      .getConsolidatedFilterGroupStateMap()
      .get(filterGroup)
  }

  isShareClassSelected(): boolean {
    if (this.filterState.overrideShareClassFlag) {
      return true
    }
    return this.filterState.getAllShareClassFlagSelection()
  }

  isBenchMarkSelected(): boolean {
    return this.filterState.getBenchMarkFlagSelection()
  }

  getLatestFilterSelection(): string {
    return this.filterState.getLatestFilterSelection()
  }

  getFilterStateAsUrlParamObj(): any {
    const filterStateUrlParamObj: any = {
      filters: '',
      shareClass: '',
      benchmark: '',
      viewType: MONTH_END_RETURN_NAV,
    }

    this.filterState
      .getUIFilterSelectionMap()
      .forEach((filterSelectionAry: string[]) => {
        filterSelectionAry.forEach((filterSelection) => {
          filterStateUrlParamObj.filters += filterSelection + ','
        })
      })
    filterStateUrlParamObj.shareClass = this.isShareClassSelected()
    filterStateUrlParamObj.benchmark = this.isBenchMarkSelected()
    if (this.getDisplaySelection() && this.getDisplaySelection().length > 0) {
      filterStateUrlParamObj.viewType = this.getDisplaySelection()
    }

    return filterStateUrlParamObj
  }
}
